import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface SessionState {
  uid: string | null;
  company_id: string | null;
  mapped_branch_id: string[] | null;
  roles: any[];
  role_type: any;
}

const initialState: SessionState = {
  uid: null,
  company_id: null,
  mapped_branch_id: [],
  roles: [],
  role_type:null
};

const sessionSlice = createSlice({
  name: "session",
  initialState,
  reducers: {
    setSession: (state, action: PayloadAction<SessionState>) => {
      return { ...state, ...action.payload };
    },
    clearSession: () => initialState,
  },
});

export const { setSession, clearSession } = sessionSlice.actions;
export default sessionSlice.reducer;
